import axios from './axios'
import config from '../config'

export default {
    listPortals(params) {
        return axios({
            url: config.backendUrl + '/project/portals',
            method: 'GET',
            params
        })
    },
    addPortal(data) {
        return axios({
            url: config.backendUrl + '/project/portals',
            method: 'POST',
            data
        })
    },
    updatePortal(data) {
        return axios({
            url: config.backendUrl + '/project/portals',
            method: 'PUT',
            data
        })
    },
    getPortal(id) {
        return axios({
            url: config.backendUrl + '/project/portals/' + id,
            method: 'GET'
        })
    },
    deletePortal(id) {
        return axios({
            url: config.backendUrl + '/project/portals/' + id,
            method: 'DELETE'
        })
    },
    buildPortalPageTree(pages){
        const rootNodes = []
        const map = new Map()
        for(const page of pages){
            map.set(page.id, page)
        }
        for(const page of pages){
            if(page.parent){
                const parent = map.get(page.parent)
                if(parent){
                    if(parent.children){
                        parent.children.push(page)
                    }else{
                        parent.children = [page]
                    }
                    page.parentPage = parent
                }else{
                    // 没有权限查看父节点，将该节点提升为根节点
                    rootNodes.push(page)
                }
            }else{
                rootNodes.push(page)
            }
            if(page.prevPageId){
                page.prevPage = map.get(page.prevPageId)
            }
        }
        const stack = [...rootNodes]
        const comparator = (a,b) => a.seqNo - b.seqNo
        while(stack.length>0){
            const node = stack.shift()
            if(node.children){
                node.children.sort(comparator)
                stack.push(...node.children)
            }
        }
        rootNodes.sort(comparator)
        return rootNodes
    }
}
